import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  const currentYear = new Date()?.getFullYear();

  return (
    <footer className="w-full bg-gradient-to-br from-[#1B5E20] via-[#2E7D32] to-[#1B5E20] border-t border-green-900/30 py-12">
      <div className="container mx-auto px-6">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <Link href="/homepage" className="text-lg font-semibold text-white hover:text-green-300 transition-colors mb-4 inline-block">
              Gelle Cleaning LLC
            </Link>
            <p className="text-sm text-green-200 mb-4">
              Professional cleaning services in the Twin Cities. Eco-friendly, reliable, and trusted since 2010.
            </p>
            {/* Social Media Links */}
            <div className="flex items-center gap-3">
              <a 
                href="https://facebook.com/gellecleaning" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-green-200 hover:bg-white/20 hover:text-white transition-colors"
                aria-label="Facebook"
              >
                <Icon name="ShareIcon" size={18} variant="outline" />
              </a>
              <a 
                href="https://instagram.com/gellecleaning" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-green-200 hover:bg-white/20 hover:text-white transition-colors"
                aria-label="Instagram"
              >
                <Icon name="CameraIcon" size={18} variant="outline" />
              </a>
              <a 
                href="https://linkedin.com/company/gellecleaning" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-green-200 hover:bg-white/20 hover:text-white transition-colors"
                aria-label="LinkedIn"
              >
                <Icon name="BuildingOfficeIcon" size={18} variant="outline" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-white mb-4">Services</h3>
            <nav className="flex flex-col gap-2">
              <Link href="/homepage#services" className="text-sm text-green-200 hover:text-white transition-colors">
                Deep Cleaning
              </Link>
              <Link href="/homepage#services" className="text-sm text-green-200 hover:text-white transition-colors">
                Standard Cleaning
              </Link>
              <Link href="/homepage#services" className="text-sm text-green-200 hover:text-white transition-colors">
                Move-In/Out
              </Link>
              <Link href="/homepage#services" className="text-sm text-green-200 hover:text-white transition-colors">
                Office Cleaning
              </Link>
            </nav>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold text-white mb-4">Company</h3>
            <nav className="flex flex-col gap-2">
              <Link href="/about" className="text-sm text-green-200 hover:text-white transition-colors">
                About Us
              </Link>
              <Link href="/service-areas" className="text-sm text-green-200 hover:text-white transition-colors">
                Service Areas
              </Link>
              <Link href="/gallery" className="text-sm text-green-200 hover:text-white transition-colors">
                Gallery
              </Link>
              <Link href="/testimonials" className="text-sm text-green-200 hover:text-white transition-colors">
                Testimonials
              </Link>
              <Link href="/blog" className="text-sm text-green-200 hover:text-white transition-colors">
                Blog
              </Link>
            </nav>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-semibold text-white mb-4">Support</h3>
            <nav className="flex flex-col gap-2">
              <Link href="/contact" className="text-sm text-green-200 hover:text-white transition-colors">
                Contact Us
              </Link>
              <Link href="/faq" className="text-sm text-green-200 hover:text-white transition-colors">
                FAQ
              </Link>
              <Link href="/homepage#booking" className="text-sm text-green-200 hover:text-white transition-colors">
                Book Now
              </Link>
              <Link href="/customer/login" className="text-sm text-green-200 hover:text-white transition-colors">
                Customer Portal
              </Link>
              <Link href="/admin" className="text-sm text-green-200 hover:text-white transition-colors">
                Admin
              </Link>
            </nav>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <span className="text-sm text-green-300">
            © {currentYear} Gelle Cleaning LLC. All rights reserved.
          </span>
          <div className="flex items-center gap-6">
            <Link href="/privacy" className="text-sm text-green-300 hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link href="/terms" className="text-sm text-green-300 hover:text-white transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}